// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.counsellor-overlay-figure {
  margin: 1rem 0 1.5rem;
}

.counsellor-overlay-grid {
  display: grid;
  gap: 1rem;
}

.counsellor-overlay-grid--pipeline {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.counsellor-overlay-grid--metrics {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.counsellor-overlay-grid--triple {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.counsellor-overlay-card {
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 14px;
  background:
    linear-gradient(180deg, rgba(248, 250, 252, 0.96) 0%, rgba(241, 245, 249, 0.94) 100%);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
  padding: 1rem;
  min-height: 100%;
}

.counsellor-overlay-card h4 {
  margin: 0 0 0.4rem;
  font-size: 0.94rem;
  color: #0f172a;
}

.counsellor-overlay-card p {
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.55;
  color: #475569;
}

.counsellor-overlay-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0f766e;
  font-size: 1.4rem;
  font-weight: 700;
}

.counsellor-overlay-accent-card {
  border: 1px dashed rgba(15, 118, 110, 0.4);
  background: rgba(240, 253, 250, 0.82);
}

.counsellor-overlay-metric-card {
  text-align: center;
}

.counsellor-overlay-stage-card {
  position: relative;
  padding-top: 2.25rem;
}

.counsellor-overlay-stage-index {
  position: absolute;
  top: 0.95rem;
  right: 0.95rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 999px;
  background: rgba(15, 118, 110, 0.12);
  color: #0f766e;
  font-size: 0.8rem;
  font-weight: 800;
}

.counsellor-overlay-metric-value {
  display: block;
  margin-bottom: 0.3rem;
  font-size: 1.45rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.03em;
}

.counsellor-overlay-metric-label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.78rem;
  font-weight: 700;
  color: #0f766e;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.counsellor-overlay-metric-note {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.45;
  color: #475569;
}

.counsellor-overlay-track {
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 16px;
  overflow: hidden;
  background: rgba(248, 250, 252, 0.92);
}

.counsellor-overlay-track-bars {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.counsellor-overlay-track-bar {
  padding: 1rem 1rem 0.9rem;
}

.counsellor-overlay-track-bar--confidence {
  background: linear-gradient(180deg, rgba(219, 234, 254, 0.95) 0%, rgba(239, 246, 255, 0.95) 100%);
}

.counsellor-overlay-track-bar--hybrid {
  background: linear-gradient(180deg, rgba(254, 242, 242, 0.92) 0%, rgba(255, 241, 242, 0.94) 100%);
}

.counsellor-overlay-track-label {
  display: block;
  margin-bottom: 0.55rem;
  font-size: 0.82rem;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.counsellor-overlay-track-line {
  position: relative;
  height: 88px;
  border-left: 2px solid rgba(100, 116, 139, 0.24);
  border-bottom: 2px solid rgba(100, 116, 139, 0.24);
}

.counsellor-overlay-track-line svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.counsellor-overlay-track-line path {
  fill: none;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.counsellor-overlay-track-bar--confidence .counsellor-overlay-track-line path {
  stroke: #2563eb;
}

.counsellor-overlay-track-bar--hybrid .counsellor-overlay-track-line path {
  stroke: #dc2626;
}

.counsellor-overlay-track-caption {
  margin: 0;
  padding: 0.8rem 1rem 0.95rem;
  font-size: 0.82rem;
  color: #475569;
  border-top: 1px solid rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.7);
}

.App.dark .counsellor-overlay-card,
.app-overlay-root.dark .counsellor-overlay-card {
  border-color: rgba(71, 85, 105, 0.72);
  background:
    linear-gradient(180deg, rgba(28, 38, 48, 0.97) 0%, rgba(20, 28, 38, 0.96) 100%);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.24);
}

.App.dark .counsellor-overlay-card h4,
.app-overlay-root.dark .counsellor-overlay-card h4 {
  color: #f8fafc;
}

.App.dark .counsellor-overlay-card p,
.app-overlay-root.dark .counsellor-overlay-card p {
  color: #cbd5e1;
}

.App.dark .counsellor-overlay-arrow,
.app-overlay-root.dark .counsellor-overlay-arrow {
  color: #34d399;
}

.App.dark .counsellor-overlay-accent-card,
.app-overlay-root.dark .counsellor-overlay-accent-card {
  border-color: rgba(52, 211, 153, 0.36);
  background: rgba(6, 78, 59, 0.2);
}

.App.dark .counsellor-overlay-metric-value,
.app-overlay-root.dark .counsellor-overlay-metric-value {
  color: #f8fafc;
}

.App.dark .counsellor-overlay-metric-label,
.app-overlay-root.dark .counsellor-overlay-metric-label {
  color: #6ee7b7;
}

.App.dark .counsellor-overlay-metric-note,
.app-overlay-root.dark .counsellor-overlay-metric-note {
  color: #cbd5e1;
}

.App.dark .counsellor-overlay-stage-index,
.app-overlay-root.dark .counsellor-overlay-stage-index {
  background: rgba(52, 211, 153, 0.16);
  color: #6ee7b7;
}

.App.dark .counsellor-overlay-track,
.app-overlay-root.dark .counsellor-overlay-track {
  border-color: rgba(71, 85, 105, 0.72);
  background: rgba(15, 23, 42, 0.78);
}

.App.dark .counsellor-overlay-track-bar--confidence,
.app-overlay-root.dark .counsellor-overlay-track-bar--confidence {
  background: linear-gradient(180deg, rgba(30, 64, 175, 0.4) 0%, rgba(30, 41, 59, 0.25) 100%);
}

.App.dark .counsellor-overlay-track-bar--hybrid,
.app-overlay-root.dark .counsellor-overlay-track-bar--hybrid {
  background: linear-gradient(180deg, rgba(127, 29, 29, 0.46) 0%, rgba(69, 10, 10, 0.28) 100%);
}

.App.dark .counsellor-overlay-track-label,
.app-overlay-root.dark .counsellor-overlay-track-label {
  color: #e2e8f0;
}

.App.dark .counsellor-overlay-track-line,
.app-overlay-root.dark .counsellor-overlay-track-line {
  border-left-color: rgba(148, 163, 184, 0.28);
  border-bottom-color: rgba(148, 163, 184, 0.28);
}

.App.dark .counsellor-overlay-track-caption,
.app-overlay-root.dark .counsellor-overlay-track-caption {
  color: #cbd5e1;
  border-top-color: rgba(71, 85, 105, 0.72);
  background: rgba(15, 23, 42, 0.5);
}

@media (max-width: 900px) {
  .counsellor-overlay-grid--pipeline,
  .counsellor-overlay-grid--metrics,
  .counsellor-overlay-grid--triple {
    grid-template-columns: 1fr;
  }

  .counsellor-overlay-arrow {
    transform: rotate(90deg);
  }

  .counsellor-overlay-track-bars {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/overlays/CounsellorsOverlay.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB;yFACuF;EACvF,8CAA8C;EAC9C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;;EAEE,qCAAqC;EACrC;mFACiF;EACjF,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;;EAEE,2FAA2F;AAC7F;;AAEA;;EAEE,4FAA4F;AAC9F;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;;EAEE,cAAc;EACd,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".counsellor-overlay-figure {\n  margin: 1rem 0 1.5rem;\n}\n\n.counsellor-overlay-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n.counsellor-overlay-grid--pipeline {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.counsellor-overlay-grid--metrics {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.counsellor-overlay-grid--triple {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.counsellor-overlay-card {\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  border-radius: 14px;\n  background:\n    linear-gradient(180deg, rgba(248, 250, 252, 0.96) 0%, rgba(241, 245, 249, 0.94) 100%);\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);\n  padding: 1rem;\n  min-height: 100%;\n}\n\n.counsellor-overlay-card h4 {\n  margin: 0 0 0.4rem;\n  font-size: 0.94rem;\n  color: #0f172a;\n}\n\n.counsellor-overlay-card p {\n  margin: 0;\n  font-size: 0.84rem;\n  line-height: 1.55;\n  color: #475569;\n}\n\n.counsellor-overlay-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0f766e;\n  font-size: 1.4rem;\n  font-weight: 700;\n}\n\n.counsellor-overlay-accent-card {\n  border: 1px dashed rgba(15, 118, 110, 0.4);\n  background: rgba(240, 253, 250, 0.82);\n}\n\n.counsellor-overlay-metric-card {\n  text-align: center;\n}\n\n.counsellor-overlay-stage-card {\n  position: relative;\n  padding-top: 2.25rem;\n}\n\n.counsellor-overlay-stage-index {\n  position: absolute;\n  top: 0.95rem;\n  right: 0.95rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.6rem;\n  height: 1.6rem;\n  border-radius: 999px;\n  background: rgba(15, 118, 110, 0.12);\n  color: #0f766e;\n  font-size: 0.8rem;\n  font-weight: 800;\n}\n\n.counsellor-overlay-metric-value {\n  display: block;\n  margin-bottom: 0.3rem;\n  font-size: 1.45rem;\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.03em;\n}\n\n.counsellor-overlay-metric-label {\n  display: block;\n  margin-bottom: 0.35rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #0f766e;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.counsellor-overlay-metric-note {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.45;\n  color: #475569;\n}\n\n.counsellor-overlay-track {\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  border-radius: 16px;\n  overflow: hidden;\n  background: rgba(248, 250, 252, 0.92);\n}\n\n.counsellor-overlay-track-bars {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.counsellor-overlay-track-bar {\n  padding: 1rem 1rem 0.9rem;\n}\n\n.counsellor-overlay-track-bar--confidence {\n  background: linear-gradient(180deg, rgba(219, 234, 254, 0.95) 0%, rgba(239, 246, 255, 0.95) 100%);\n}\n\n.counsellor-overlay-track-bar--hybrid {\n  background: linear-gradient(180deg, rgba(254, 242, 242, 0.92) 0%, rgba(255, 241, 242, 0.94) 100%);\n}\n\n.counsellor-overlay-track-label {\n  display: block;\n  margin-bottom: 0.55rem;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #334155;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.counsellor-overlay-track-line {\n  position: relative;\n  height: 88px;\n  border-left: 2px solid rgba(100, 116, 139, 0.24);\n  border-bottom: 2px solid rgba(100, 116, 139, 0.24);\n}\n\n.counsellor-overlay-track-line svg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.counsellor-overlay-track-line path {\n  fill: none;\n  stroke-width: 4;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.counsellor-overlay-track-bar--confidence .counsellor-overlay-track-line path {\n  stroke: #2563eb;\n}\n\n.counsellor-overlay-track-bar--hybrid .counsellor-overlay-track-line path {\n  stroke: #dc2626;\n}\n\n.counsellor-overlay-track-caption {\n  margin: 0;\n  padding: 0.8rem 1rem 0.95rem;\n  font-size: 0.82rem;\n  color: #475569;\n  border-top: 1px solid rgba(148, 163, 184, 0.22);\n  background: rgba(255, 255, 255, 0.7);\n}\n\n.App.dark .counsellor-overlay-card,\n.app-overlay-root.dark .counsellor-overlay-card {\n  border-color: rgba(71, 85, 105, 0.72);\n  background:\n    linear-gradient(180deg, rgba(28, 38, 48, 0.97) 0%, rgba(20, 28, 38, 0.96) 100%);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.24);\n}\n\n.App.dark .counsellor-overlay-card h4,\n.app-overlay-root.dark .counsellor-overlay-card h4 {\n  color: #f8fafc;\n}\n\n.App.dark .counsellor-overlay-card p,\n.app-overlay-root.dark .counsellor-overlay-card p {\n  color: #cbd5e1;\n}\n\n.App.dark .counsellor-overlay-arrow,\n.app-overlay-root.dark .counsellor-overlay-arrow {\n  color: #34d399;\n}\n\n.App.dark .counsellor-overlay-accent-card,\n.app-overlay-root.dark .counsellor-overlay-accent-card {\n  border-color: rgba(52, 211, 153, 0.36);\n  background: rgba(6, 78, 59, 0.2);\n}\n\n.App.dark .counsellor-overlay-metric-value,\n.app-overlay-root.dark .counsellor-overlay-metric-value {\n  color: #f8fafc;\n}\n\n.App.dark .counsellor-overlay-metric-label,\n.app-overlay-root.dark .counsellor-overlay-metric-label {\n  color: #6ee7b7;\n}\n\n.App.dark .counsellor-overlay-metric-note,\n.app-overlay-root.dark .counsellor-overlay-metric-note {\n  color: #cbd5e1;\n}\n\n.App.dark .counsellor-overlay-stage-index,\n.app-overlay-root.dark .counsellor-overlay-stage-index {\n  background: rgba(52, 211, 153, 0.16);\n  color: #6ee7b7;\n}\n\n.App.dark .counsellor-overlay-track,\n.app-overlay-root.dark .counsellor-overlay-track {\n  border-color: rgba(71, 85, 105, 0.72);\n  background: rgba(15, 23, 42, 0.78);\n}\n\n.App.dark .counsellor-overlay-track-bar--confidence,\n.app-overlay-root.dark .counsellor-overlay-track-bar--confidence {\n  background: linear-gradient(180deg, rgba(30, 64, 175, 0.4) 0%, rgba(30, 41, 59, 0.25) 100%);\n}\n\n.App.dark .counsellor-overlay-track-bar--hybrid,\n.app-overlay-root.dark .counsellor-overlay-track-bar--hybrid {\n  background: linear-gradient(180deg, rgba(127, 29, 29, 0.46) 0%, rgba(69, 10, 10, 0.28) 100%);\n}\n\n.App.dark .counsellor-overlay-track-label,\n.app-overlay-root.dark .counsellor-overlay-track-label {\n  color: #e2e8f0;\n}\n\n.App.dark .counsellor-overlay-track-line,\n.app-overlay-root.dark .counsellor-overlay-track-line {\n  border-left-color: rgba(148, 163, 184, 0.28);\n  border-bottom-color: rgba(148, 163, 184, 0.28);\n}\n\n.App.dark .counsellor-overlay-track-caption,\n.app-overlay-root.dark .counsellor-overlay-track-caption {\n  color: #cbd5e1;\n  border-top-color: rgba(71, 85, 105, 0.72);\n  background: rgba(15, 23, 42, 0.5);\n}\n\n@media (max-width: 900px) {\n  .counsellor-overlay-grid--pipeline,\n  .counsellor-overlay-grid--metrics,\n  .counsellor-overlay-grid--triple {\n    grid-template-columns: 1fr;\n  }\n\n  .counsellor-overlay-arrow {\n    transform: rotate(90deg);\n  }\n\n  .counsellor-overlay-track-bars {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
